import { StyleSheet, View } from 'react-native';
import { useTheme } from '@ui-kitten/components';

import Button from '../../../../Components/Button';
import { textCategory } from '../../../../Components/Reservation/constants';
import ReservationOverview from '../../../../Components/Reservation/Overview';
import ResponsiveText from '../../../../Components/ResponsiveText';
import TicketIcon from '../../../../Components/SVG/Tickets';
import { EventDetails } from '../../../../RTK/api/events/types';
import themeColor from '../../../../Theme/colors';
import themeStyle from '../../../../Theme/styles';

import cardStyles from './styles';

type Props = EventDetails & {
  onPress: () => void;
};
const Ticket = (props) => (
  <TicketIcon
    {...props}
    fill={themeColor.white}
    style={styles.iconBtn}
    width={30}
    height={30}
  />
);
const ReservationCardEvent = ({
  available_days,
  end_date,
  name,
  start_date,
  tickets,
  time_slots,
  onPress,
}: Props) => {
  const theme = useTheme();
  return (
    <View
      style={[
        cardStyles.listItemWrapper,
        { borderColor: theme['color-info-500'] },
      ]}
    >
      <View style={themeStyle.spacingBottomSmall}>
        <ResponsiveText
          category={textCategory.BODY}
          numberOfLines={1}
          style={[themeStyle.bold, themeStyle.spacingBottomSmall]}
        >
          {name}
        </ResponsiveText>
        <ReservationOverview
          contentContainerStyle={themeStyle.spacingBottomXXSmall}
          iconSize={15}
          textCategory={textCategory.SMALL_BODY}
          eventData={{
            available_days,
            end_date,
            tickets,
            time_slots,
            start_date,
          }}
        />
      </View>
      <View style={themeStyle.alignItemsStart}>
        <Button
          accessoryLeft={Ticket}
          status="info"
          onPress={onPress}
          style={cardStyles.btn}
        >
          Get Tickets
        </Button>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  iconBtn: {
    marginLeft: 5,
    marginRight: 0,
  },
});

export default ReservationCardEvent;
